var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const baseParams = url.indexOf("=") >= 0 ? url.substring(url.indexOf("=") + 1).split("-") : [];
  const mergedParams = {};
  baseParams.forEach((param) => {
    var _a;
    if (["rw", "rp", "rj"].includes(param)) {
      mergedParams["format"] = param;
    } else {
      const prefix = (_a = param.match(/^([a-z]+)(\w*)$/)) == null ? void 0 : _a[1];
      if (prefix) {
        mergedParams[prefix] = param;
      }
    }
  });
  if (config.width && !config.height) {
    delete mergedParams["h"];
    delete mergedParams["s"];
  }
  if (config.height && !config.width) {
    delete mergedParams["w"];
    delete mergedParams["s"];
  }
  Object.entries(config).forEach(([key, value]) => {
    if (typeof value !== "boolean" && !value)
      return;
    if (key === "format") {
      const gcsArg = imgAttributeMapping[value];
      mergedParams["format"] = gcsArg;
      return;
    }
    const gcsArgPrefix = imgAttributeMapping[key];
    if (key === "size" && value) {
      mergedParams[gcsArgPrefix] = `${gcsArgPrefix}0`;
      return;
    }
    if (gcsArgPrefix) {
      if (typeof value === "boolean") {
        mergedParams[gcsArgPrefix] = value ? gcsArgPrefix : void 0;
      } else {
        mergedParams[gcsArgPrefix] = `${gcsArgPrefix}${value}`;
      }
    }
  });
  const filterParams = Object.values(mergedParams).filter((param) => param);
  return filterParams.some((param) => param) ? `${baseUrl}=${filterParams.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com"))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};
const imageLoader = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    const googleParams = __spreadProps(__spreadValues({}, config || {}), {
      format: (config == null ? void 0 : config.format) || "webp"
    });
    return {
      src: constructGoogleImageParams(imageUrl, googleParams),
      params: googleParams
    };
  }
  return { src: imageUrl };
};

export { constructGoogleImageParams, getImageUrlFromGoogleUserContent, imageLoader };
